module.exports = __webpack_public_path__ + "static/small-b31e2aefc62d484d783f44036fe7530d.webp";